export var selectFolders = function selectFolders(state) {
  return state.favoritesAssignWidget.folders;
};